// The only addresses where forms are allowed to send.
// Anywhere else (Azure PR previews, local builds) forms are switched off,
// because every build points at the LIVE Function App.
export const LIVE_HOSTS = [
  'clinicalminds.net',
  'www.clinicalminds.net',
  'monivae.clinicalminds.net',
];

export function isLiveSite() {
  if (typeof window === 'undefined') return false;
  return LIVE_HOSTS.includes(window.location.hostname);
}

// Safety net: off the live site, block any POST to the Function App, even from
// a form that was missed. Installed once from index.js.
export function blockFormPostsOffLiveSite(backendUrl) {
  if (typeof window === 'undefined' || isLiveSite() || !window.fetch || !backendUrl) return;
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = (init.method || (input && input.method) || 'GET').toUpperCase();
    if (method !== 'GET' && url.startsWith(backendUrl)) {
      return Promise.reject(new Error('Forms are switched off on this preview.'));
    }
    return originalFetch(input, init);
  };
}
